import { TRESPONSE_BUNDLE_TAG_DETAILS } from '@monorepo/types';
import { ModifiersZTableModel } from '@monorepo/ui';

export const COMPONENT_BUNDLE_TAG_MODEL = {
  createModel: (items: TRESPONSE_BUNDLE_TAG_DETAILS['component_tags_details']) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'cutbank_common.component_name',
          },
          {
            type: 'TEXT_CELL',
            text: 'cutbank_common.component_tag_id',
          },
          {
            type: 'TEXT_CELL',
            text: 'cutbank_common.qty',
          },

          {
            type: 'TEXT_CELL',
            text: 'cutbank_out_rf_id_scan.status',
          },
          {
            type: 'TEXT_CELL',
            text: 'common.actions',
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.component_type,
            },
            {
              type: 'TEXT_CELL',
              text: item.component_tag_display_id,
            },
            {
              type: 'TEXT_CELL',
              text: item.current_scan_quantity || 0,
            },
            {
              type: 'TEXT_CELL',
              text: item.component_tag_scan_status,
              textColor: item.component_tag_scan_status === 'COMPLETELY_SCANNED' ? 'GREEN' : 'RED',
            },
            {
              type: 'TEXT_CELL',
              text: 'cutbank_commonexpan_details',
              hrefActionCB: item.component_tag_id,
              textColor: 'BLUE',
            },
          ],
        };
      },
    );
  },
};
